export default class Modal {
  constructor(
    selector = '[data-modal]',
    activeClass = 'active'
  ) {
    this.body = document.querySelector('body');
    this.triggers = Array.from(document.querySelectorAll(selector));
    this.activeClass = activeClass;

    this.events();
  }

  events() {
    this.triggerHandle = this.triggerHandle.bind(this);
    this.outsideClickHandler = this.outsideClickHandler.bind(this);
    this.closeKeyHandler = this.closeKeyHandler.bind(this);
    this.closeModalHandler = this.closeModal.bind(this);
    this.modalPager = this.modalPager.bind(this);

    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', this.triggerHandle, false);
    });
  }

  triggerHandle(e) {
    // console.log('triggerHandle:', e)
    e.stopPropagation();
    e.preventDefault();

    const el = e.currentTarget;
    const aim = el.getAttribute('data-modal');

    const target = document.getElementById(aim) ||
      document.querySelector(`[data-modal-target="${aim}"]`);

    target ? this.toggleModal(target) : console.log('no target', target, e);
  }

  toggleModal(el) {
    // console.log('toggle modal', el);
    el.classList.contains(this.activeClass) ? this.closeModal() : this.openModal(el);
  }

  closeModal(e) {
    // console.log('closing modal', this.modal);
    if (this.modal) {
      // Stop the event bubbling to open if modal is inside of a data-modal reference
      if(e) e.stopPropagation();
      this.modal.classList.remove(this.activeClass);
      this.removeListeners();
      this.body.classList.remove('modal-open');
      this.handleVideo(false);
      this.modal = null;
      this.modalPagers = null;
      // trying to fix iOS
      document.querySelector('html').classList.remove('modal-open');
    } else {
      console.log('no modal to close');
    }
  }

  openModal(el) {
    // console.log('openmodal', el);
    this.setModalDom(el);
    this.body.classList.add('modal-open');
      // trying to fix iOS
    document.querySelector('html').classList.add('modal-open');
    this.modal.classList.add(this.activeClass);
    this.listen();
    this.handleVideo(true);
  }

  setModalDom(el) {
    this.modal = el;
    this.modalContainer = el.querySelector('.modal__container');
    this.modalContent = el.querySelector('.modal__content');
    this.modalClose = Array.from(el.querySelectorAll('[data-modal-close]'));
    this.modalPagers = Array.from(this.modal.querySelectorAll('[data-modal-pager]'))
  }

  removeListeners() {
    if (this.listening) {
      this.body.removeEventListener('click', this.outsideClickHandler);
      this.body.removeEventListener('keydown', this.closeKeyHandler);

      if(this.modalPagers){
        this.modalPagers.forEach(el => el.removeEventListener('click', this.modalPager))
      }
      this.listening = false;
    }
  }

  listen() {
    this.body.addEventListener('click', this.outsideClickHandler, false);
    this.body.addEventListener('keydown', this.closeKeyHandler, false);

    if(this.modalPagers){
      this.modalPagers.forEach(el => el.addEventListener('click', this.modalPager))
    }
    this.modalClose.forEach(close =>
      close.addEventListener('click', this.closeModalHandler, false)
      );
    this.listening = true;
  }

  closeKeyHandler(e) {
    if (this.modal && e.which === 27) {
      e.preventDefault();
      this.closeModal();
    }
  }

  outsideClickHandler(e) {
    let node = e.target;
    while (node && node !== this.body) {
      // console.log('checkingNodes:', node);
      if (node === this.modalContainer) {
        // console.log('dont close');
        return;
      }
      node = node.parentNode;
    }
    // console.log('outside click');
    this.closeModal(e);
  }

  handleVideo(play){
    const iframe = this.modal.querySelector('iframe')
    if (iframe){
      const iframeContent = iframe.contentWindow
      const iframeCommand = JSON.stringify( { 
        event: 'command',
        func: play ? 'playVideo' : 'pauseVideo'
      } )
      iframeContent.postMessage(iframeCommand, '*');
    }
  }

  modalPager(e){
    const element = e.target
    const index = element.getAttribute('data-modal-pager')
    const target = document.querySelector(`[data-modal-index="${index}"]`)

    this.closeModal()
    // Delay to allow for the current modal to close
    setTimeout(()=>{
      this.openModal(target)
    }, 300)
  }

}